/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as ClientIdRouteImport } from "./routes/$clientId";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as ClientIdIndexRouteImport } from "./routes/$clientId/index";
import { Route as ClientIdSidecarIndexRouteImport } from "./routes/$clientId/sidecar/index";
import { Route as ClientIdHostsIndexRouteImport } from "./routes/$clientId/hosts/index";
import { Route as ClientIdFileLockerIndexRouteImport } from "./routes/$clientId/file-locker/index";
import { Route as ClientIdBillingIndexRouteImport } from "./routes/$clientId/billing/index";
import { Route as ClientIdSidecarCreateRouteImport } from "./routes/$clientId/sidecar/create";
import { Route as ClientIdHostsHostIdRouteImport } from "./routes/$clientId/hosts/$hostId";
import { Route as ClientIdHostsHostIdIndexRouteImport } from "./routes/$clientId/hosts/$hostId/index";
import { Route as ClientIdHostsHostIdWebdirectAutoScalingIndexRouteImport } from "./routes/$clientId/hosts/$hostId/webdirect-auto-scaling/index";
import { Route as ClientIdHostsHostIdVolumesIndexRouteImport } from "./routes/$clientId/hosts/$hostId/volumes/index";
import { Route as ClientIdHostsHostIdSnapbackIndexRouteImport } from "./routes/$clientId/hosts/$hostId/snapback/index";
import { Route as ClientIdHostsHostIdPrivateBackupIndexRouteImport } from "./routes/$clientId/hosts/$hostId/private-backup/index";
import { Route as ClientIdHostsHostIdFmsIndexRouteImport } from "./routes/$clientId/hosts/$hostId/fms/index";
import { Route as ClientIdHostsHostIdEventsIndexRouteImport } from "./routes/$clientId/hosts/$hostId/events/index";
import { Route as ClientIdHostsHostIdDynamicDocketIndexRouteImport } from "./routes/$clientId/hosts/$hostId/dynamic-docket/index";
import { Route as ClientIdHostsHostIdDisasterRecoveryIndexRouteImport } from "./routes/$clientId/hosts/$hostId/disaster-recovery/index";

const ClientIdRoute = ClientIdRouteImport.update({
  id: "/$clientId",
  path: "/$clientId",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const ClientIdIndexRoute = ClientIdIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ClientIdRoute,
} as any);
const ClientIdSidecarIndexRoute = ClientIdSidecarIndexRouteImport.update({
  id: "/sidecar/",
  path: "/sidecar/",
  getParentRoute: () => ClientIdRoute,
} as any);
const ClientIdHostsIndexRoute = ClientIdHostsIndexRouteImport.update({
  id: "/hosts/",
  path: "/hosts/",
  getParentRoute: () => ClientIdRoute,
} as any);
const ClientIdFileLockerIndexRoute = ClientIdFileLockerIndexRouteImport.update({
  id: "/file-locker/",
  path: "/file-locker/",
  getParentRoute: () => ClientIdRoute,
} as any);
const ClientIdBillingIndexRoute = ClientIdBillingIndexRouteImport.update({
  id: "/billing/",
  path: "/billing/",
  getParentRoute: () => ClientIdRoute,
} as any);
const ClientIdSidecarCreateRoute = ClientIdSidecarCreateRouteImport.update({
  id: "/sidecar/create",
  path: "/sidecar/create",
  getParentRoute: () => ClientIdRoute,
} as any);
const ClientIdHostsHostIdRoute = ClientIdHostsHostIdRouteImport.update({
  id: "/hosts/$hostId",
  path: "/hosts/$hostId",
  getParentRoute: () => ClientIdRoute,
} as any);
const ClientIdHostsHostIdIndexRoute =
  ClientIdHostsHostIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ClientIdHostsHostIdRoute,
  } as any);
const ClientIdHostsHostIdWebdirectAutoScalingIndexRoute =
  ClientIdHostsHostIdWebdirectAutoScalingIndexRouteImport.update({
    id: "/webdirect-auto-scaling/",
    path: "/webdirect-auto-scaling/",
    getParentRoute: () => ClientIdHostsHostIdRoute,
  } as any);
const ClientIdHostsHostIdVolumesIndexRoute =
  ClientIdHostsHostIdVolumesIndexRouteImport.update({
    id: "/volumes/",
    path: "/volumes/",
    getParentRoute: () => ClientIdHostsHostIdRoute,
  } as any);
const ClientIdHostsHostIdSnapbackIndexRoute =
  ClientIdHostsHostIdSnapbackIndexRouteImport.update({
    id: "/snapback/",
    path: "/snapback/",
    getParentRoute: () => ClientIdHostsHostIdRoute,
  } as any);
const ClientIdHostsHostIdPrivateBackupIndexRoute =
  ClientIdHostsHostIdPrivateBackupIndexRouteImport.update({
    id: "/private-backup/",
    path: "/private-backup/",
    getParentRoute: () => ClientIdHostsHostIdRoute,
  } as any);
const ClientIdHostsHostIdFmsIndexRoute =
  ClientIdHostsHostIdFmsIndexRouteImport.update({
    id: "/fms/",
    path: "/fms/",
    getParentRoute: () => ClientIdHostsHostIdRoute,
  } as any);
const ClientIdHostsHostIdEventsIndexRoute =
  ClientIdHostsHostIdEventsIndexRouteImport.update({
    id: "/events/",
    path: "/events/",
    getParentRoute: () => ClientIdHostsHostIdRoute,
  } as any);
const ClientIdHostsHostIdDynamicDocketIndexRoute =
  ClientIdHostsHostIdDynamicDocketIndexRouteImport.update({
    id: "/dynamic-docket/",
    path: "/dynamic-docket/",
    getParentRoute: () => ClientIdHostsHostIdRoute,
  } as any);
const ClientIdHostsHostIdDisasterRecoveryIndexRoute =
  ClientIdHostsHostIdDisasterRecoveryIndexRouteImport.update({
    id: "/disaster-recovery/",
    path: "/disaster-recovery/",
    getParentRoute: () => ClientIdHostsHostIdRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/$clientId": typeof ClientIdRouteWithChildren;
  "/$clientId/": typeof ClientIdIndexRoute;
  "/$clientId/hosts/$hostId": typeof ClientIdHostsHostIdRouteWithChildren;
  "/$clientId/sidecar/create": typeof ClientIdSidecarCreateRoute;
  "/$clientId/billing": typeof ClientIdBillingIndexRoute;
  "/$clientId/file-locker": typeof ClientIdFileLockerIndexRoute;
  "/$clientId/hosts": typeof ClientIdHostsIndexRoute;
  "/$clientId/sidecar": typeof ClientIdSidecarIndexRoute;
  "/$clientId/hosts/$hostId/": typeof ClientIdHostsHostIdIndexRoute;
  "/$clientId/hosts/$hostId/disaster-recovery": typeof ClientIdHostsHostIdDisasterRecoveryIndexRoute;
  "/$clientId/hosts/$hostId/dynamic-docket": typeof ClientIdHostsHostIdDynamicDocketIndexRoute;
  "/$clientId/hosts/$hostId/events": typeof ClientIdHostsHostIdEventsIndexRoute;
  "/$clientId/hosts/$hostId/fms": typeof ClientIdHostsHostIdFmsIndexRoute;
  "/$clientId/hosts/$hostId/private-backup": typeof ClientIdHostsHostIdPrivateBackupIndexRoute;
  "/$clientId/hosts/$hostId/snapback": typeof ClientIdHostsHostIdSnapbackIndexRoute;
  "/$clientId/hosts/$hostId/volumes": typeof ClientIdHostsHostIdVolumesIndexRoute;
  "/$clientId/hosts/$hostId/webdirect-auto-scaling": typeof ClientIdHostsHostIdWebdirectAutoScalingIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/$clientId": typeof ClientIdIndexRoute;
  "/$clientId/sidecar/create": typeof ClientIdSidecarCreateRoute;
  "/$clientId/billing": typeof ClientIdBillingIndexRoute;
  "/$clientId/file-locker": typeof ClientIdFileLockerIndexRoute;
  "/$clientId/hosts": typeof ClientIdHostsIndexRoute;
  "/$clientId/sidecar": typeof ClientIdSidecarIndexRoute;
  "/$clientId/hosts/$hostId": typeof ClientIdHostsHostIdIndexRoute;
  "/$clientId/hosts/$hostId/disaster-recovery": typeof ClientIdHostsHostIdDisasterRecoveryIndexRoute;
  "/$clientId/hosts/$hostId/dynamic-docket": typeof ClientIdHostsHostIdDynamicDocketIndexRoute;
  "/$clientId/hosts/$hostId/events": typeof ClientIdHostsHostIdEventsIndexRoute;
  "/$clientId/hosts/$hostId/fms": typeof ClientIdHostsHostIdFmsIndexRoute;
  "/$clientId/hosts/$hostId/private-backup": typeof ClientIdHostsHostIdPrivateBackupIndexRoute;
  "/$clientId/hosts/$hostId/snapback": typeof ClientIdHostsHostIdSnapbackIndexRoute;
  "/$clientId/hosts/$hostId/volumes": typeof ClientIdHostsHostIdVolumesIndexRoute;
  "/$clientId/hosts/$hostId/webdirect-auto-scaling": typeof ClientIdHostsHostIdWebdirectAutoScalingIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/$clientId": typeof ClientIdRouteWithChildren;
  "/$clientId/": typeof ClientIdIndexRoute;
  "/$clientId/hosts/$hostId": typeof ClientIdHostsHostIdRouteWithChildren;
  "/$clientId/sidecar/create": typeof ClientIdSidecarCreateRoute;
  "/$clientId/billing/": typeof ClientIdBillingIndexRoute;
  "/$clientId/file-locker/": typeof ClientIdFileLockerIndexRoute;
  "/$clientId/hosts/": typeof ClientIdHostsIndexRoute;
  "/$clientId/sidecar/": typeof ClientIdSidecarIndexRoute;
  "/$clientId/hosts/$hostId/": typeof ClientIdHostsHostIdIndexRoute;
  "/$clientId/hosts/$hostId/disaster-recovery/": typeof ClientIdHostsHostIdDisasterRecoveryIndexRoute;
  "/$clientId/hosts/$hostId/dynamic-docket/": typeof ClientIdHostsHostIdDynamicDocketIndexRoute;
  "/$clientId/hosts/$hostId/events/": typeof ClientIdHostsHostIdEventsIndexRoute;
  "/$clientId/hosts/$hostId/fms/": typeof ClientIdHostsHostIdFmsIndexRoute;
  "/$clientId/hosts/$hostId/private-backup/": typeof ClientIdHostsHostIdPrivateBackupIndexRoute;
  "/$clientId/hosts/$hostId/snapback/": typeof ClientIdHostsHostIdSnapbackIndexRoute;
  "/$clientId/hosts/$hostId/volumes/": typeof ClientIdHostsHostIdVolumesIndexRoute;
  "/$clientId/hosts/$hostId/webdirect-auto-scaling/": typeof ClientIdHostsHostIdWebdirectAutoScalingIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/$clientId"
    | "/$clientId/"
    | "/$clientId/hosts/$hostId"
    | "/$clientId/sidecar/create"
    | "/$clientId/billing"
    | "/$clientId/file-locker"
    | "/$clientId/hosts"
    | "/$clientId/sidecar"
    | "/$clientId/hosts/$hostId/"
    | "/$clientId/hosts/$hostId/disaster-recovery"
    | "/$clientId/hosts/$hostId/dynamic-docket"
    | "/$clientId/hosts/$hostId/events"
    | "/$clientId/hosts/$hostId/fms"
    | "/$clientId/hosts/$hostId/private-backup"
    | "/$clientId/hosts/$hostId/snapback"
    | "/$clientId/hosts/$hostId/volumes"
    | "/$clientId/hosts/$hostId/webdirect-auto-scaling";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/$clientId"
    | "/$clientId/sidecar/create"
    | "/$clientId/billing"
    | "/$clientId/file-locker"
    | "/$clientId/hosts"
    | "/$clientId/sidecar"
    | "/$clientId/hosts/$hostId"
    | "/$clientId/hosts/$hostId/disaster-recovery"
    | "/$clientId/hosts/$hostId/dynamic-docket"
    | "/$clientId/hosts/$hostId/events"
    | "/$clientId/hosts/$hostId/fms"
    | "/$clientId/hosts/$hostId/private-backup"
    | "/$clientId/hosts/$hostId/snapback"
    | "/$clientId/hosts/$hostId/volumes"
    | "/$clientId/hosts/$hostId/webdirect-auto-scaling";
  id:
    | "__root__"
    | "/"
    | "/$clientId"
    | "/$clientId/"
    | "/$clientId/hosts/$hostId"
    | "/$clientId/sidecar/create"
    | "/$clientId/billing/"
    | "/$clientId/file-locker/"
    | "/$clientId/hosts/"
    | "/$clientId/sidecar/"
    | "/$clientId/hosts/$hostId/"
    | "/$clientId/hosts/$hostId/disaster-recovery/"
    | "/$clientId/hosts/$hostId/dynamic-docket/"
    | "/$clientId/hosts/$hostId/events/"
    | "/$clientId/hosts/$hostId/fms/"
    | "/$clientId/hosts/$hostId/private-backup/"
    | "/$clientId/hosts/$hostId/snapback/"
    | "/$clientId/hosts/$hostId/volumes/"
    | "/$clientId/hosts/$hostId/webdirect-auto-scaling/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ClientIdRoute: typeof ClientIdRouteWithChildren;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/$clientId": {
      id: "/$clientId";
      path: "/$clientId";
      fullPath: "/$clientId";
      preLoaderRoute: typeof ClientIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$clientId/": {
      id: "/$clientId/";
      path: "/";
      fullPath: "/$clientId/";
      preLoaderRoute: typeof ClientIdIndexRouteImport;
      parentRoute: typeof ClientIdRoute;
    };
    "/$clientId/sidecar/": {
      id: "/$clientId/sidecar/";
      path: "/sidecar";
      fullPath: "/$clientId/sidecar";
      preLoaderRoute: typeof ClientIdSidecarIndexRouteImport;
      parentRoute: typeof ClientIdRoute;
    };
    "/$clientId/hosts/": {
      id: "/$clientId/hosts/";
      path: "/hosts";
      fullPath: "/$clientId/hosts";
      preLoaderRoute: typeof ClientIdHostsIndexRouteImport;
      parentRoute: typeof ClientIdRoute;
    };
    "/$clientId/file-locker/": {
      id: "/$clientId/file-locker/";
      path: "/file-locker";
      fullPath: "/$clientId/file-locker";
      preLoaderRoute: typeof ClientIdFileLockerIndexRouteImport;
      parentRoute: typeof ClientIdRoute;
    };
    "/$clientId/billing/": {
      id: "/$clientId/billing/";
      path: "/billing";
      fullPath: "/$clientId/billing";
      preLoaderRoute: typeof ClientIdBillingIndexRouteImport;
      parentRoute: typeof ClientIdRoute;
    };
    "/$clientId/sidecar/create": {
      id: "/$clientId/sidecar/create";
      path: "/sidecar/create";
      fullPath: "/$clientId/sidecar/create";
      preLoaderRoute: typeof ClientIdSidecarCreateRouteImport;
      parentRoute: typeof ClientIdRoute;
    };
    "/$clientId/hosts/$hostId": {
      id: "/$clientId/hosts/$hostId";
      path: "/hosts/$hostId";
      fullPath: "/$clientId/hosts/$hostId";
      preLoaderRoute: typeof ClientIdHostsHostIdRouteImport;
      parentRoute: typeof ClientIdRoute;
    };
    "/$clientId/hosts/$hostId/": {
      id: "/$clientId/hosts/$hostId/";
      path: "/";
      fullPath: "/$clientId/hosts/$hostId/";
      preLoaderRoute: typeof ClientIdHostsHostIdIndexRouteImport;
      parentRoute: typeof ClientIdHostsHostIdRoute;
    };
    "/$clientId/hosts/$hostId/webdirect-auto-scaling/": {
      id: "/$clientId/hosts/$hostId/webdirect-auto-scaling/";
      path: "/webdirect-auto-scaling";
      fullPath: "/$clientId/hosts/$hostId/webdirect-auto-scaling";
      preLoaderRoute: typeof ClientIdHostsHostIdWebdirectAutoScalingIndexRouteImport;
      parentRoute: typeof ClientIdHostsHostIdRoute;
    };
    "/$clientId/hosts/$hostId/volumes/": {
      id: "/$clientId/hosts/$hostId/volumes/";
      path: "/volumes";
      fullPath: "/$clientId/hosts/$hostId/volumes";
      preLoaderRoute: typeof ClientIdHostsHostIdVolumesIndexRouteImport;
      parentRoute: typeof ClientIdHostsHostIdRoute;
    };
    "/$clientId/hosts/$hostId/snapback/": {
      id: "/$clientId/hosts/$hostId/snapback/";
      path: "/snapback";
      fullPath: "/$clientId/hosts/$hostId/snapback";
      preLoaderRoute: typeof ClientIdHostsHostIdSnapbackIndexRouteImport;
      parentRoute: typeof ClientIdHostsHostIdRoute;
    };
    "/$clientId/hosts/$hostId/private-backup/": {
      id: "/$clientId/hosts/$hostId/private-backup/";
      path: "/private-backup";
      fullPath: "/$clientId/hosts/$hostId/private-backup";
      preLoaderRoute: typeof ClientIdHostsHostIdPrivateBackupIndexRouteImport;
      parentRoute: typeof ClientIdHostsHostIdRoute;
    };
    "/$clientId/hosts/$hostId/fms/": {
      id: "/$clientId/hosts/$hostId/fms/";
      path: "/fms";
      fullPath: "/$clientId/hosts/$hostId/fms";
      preLoaderRoute: typeof ClientIdHostsHostIdFmsIndexRouteImport;
      parentRoute: typeof ClientIdHostsHostIdRoute;
    };
    "/$clientId/hosts/$hostId/events/": {
      id: "/$clientId/hosts/$hostId/events/";
      path: "/events";
      fullPath: "/$clientId/hosts/$hostId/events";
      preLoaderRoute: typeof ClientIdHostsHostIdEventsIndexRouteImport;
      parentRoute: typeof ClientIdHostsHostIdRoute;
    };
    "/$clientId/hosts/$hostId/dynamic-docket/": {
      id: "/$clientId/hosts/$hostId/dynamic-docket/";
      path: "/dynamic-docket";
      fullPath: "/$clientId/hosts/$hostId/dynamic-docket";
      preLoaderRoute: typeof ClientIdHostsHostIdDynamicDocketIndexRouteImport;
      parentRoute: typeof ClientIdHostsHostIdRoute;
    };
    "/$clientId/hosts/$hostId/disaster-recovery/": {
      id: "/$clientId/hosts/$hostId/disaster-recovery/";
      path: "/disaster-recovery";
      fullPath: "/$clientId/hosts/$hostId/disaster-recovery";
      preLoaderRoute: typeof ClientIdHostsHostIdDisasterRecoveryIndexRouteImport;
      parentRoute: typeof ClientIdHostsHostIdRoute;
    };
  }
}

interface ClientIdHostsHostIdRouteChildren {
  ClientIdHostsHostIdIndexRoute: typeof ClientIdHostsHostIdIndexRoute;
  ClientIdHostsHostIdDisasterRecoveryIndexRoute: typeof ClientIdHostsHostIdDisasterRecoveryIndexRoute;
  ClientIdHostsHostIdDynamicDocketIndexRoute: typeof ClientIdHostsHostIdDynamicDocketIndexRoute;
  ClientIdHostsHostIdEventsIndexRoute: typeof ClientIdHostsHostIdEventsIndexRoute;
  ClientIdHostsHostIdFmsIndexRoute: typeof ClientIdHostsHostIdFmsIndexRoute;
  ClientIdHostsHostIdPrivateBackupIndexRoute: typeof ClientIdHostsHostIdPrivateBackupIndexRoute;
  ClientIdHostsHostIdSnapbackIndexRoute: typeof ClientIdHostsHostIdSnapbackIndexRoute;
  ClientIdHostsHostIdVolumesIndexRoute: typeof ClientIdHostsHostIdVolumesIndexRoute;
  ClientIdHostsHostIdWebdirectAutoScalingIndexRoute: typeof ClientIdHostsHostIdWebdirectAutoScalingIndexRoute;
}

const ClientIdHostsHostIdRouteChildren: ClientIdHostsHostIdRouteChildren = {
  ClientIdHostsHostIdIndexRoute: ClientIdHostsHostIdIndexRoute,
  ClientIdHostsHostIdDisasterRecoveryIndexRoute:
    ClientIdHostsHostIdDisasterRecoveryIndexRoute,
  ClientIdHostsHostIdDynamicDocketIndexRoute:
    ClientIdHostsHostIdDynamicDocketIndexRoute,
  ClientIdHostsHostIdEventsIndexRoute: ClientIdHostsHostIdEventsIndexRoute,
  ClientIdHostsHostIdFmsIndexRoute: ClientIdHostsHostIdFmsIndexRoute,
  ClientIdHostsHostIdPrivateBackupIndexRoute:
    ClientIdHostsHostIdPrivateBackupIndexRoute,
  ClientIdHostsHostIdSnapbackIndexRoute: ClientIdHostsHostIdSnapbackIndexRoute,
  ClientIdHostsHostIdVolumesIndexRoute: ClientIdHostsHostIdVolumesIndexRoute,
  ClientIdHostsHostIdWebdirectAutoScalingIndexRoute:
    ClientIdHostsHostIdWebdirectAutoScalingIndexRoute,
};

const ClientIdHostsHostIdRouteWithChildren =
  ClientIdHostsHostIdRoute._addFileChildren(ClientIdHostsHostIdRouteChildren);

interface ClientIdRouteChildren {
  ClientIdIndexRoute: typeof ClientIdIndexRoute;
  ClientIdHostsHostIdRoute: typeof ClientIdHostsHostIdRouteWithChildren;
  ClientIdSidecarCreateRoute: typeof ClientIdSidecarCreateRoute;
  ClientIdBillingIndexRoute: typeof ClientIdBillingIndexRoute;
  ClientIdFileLockerIndexRoute: typeof ClientIdFileLockerIndexRoute;
  ClientIdHostsIndexRoute: typeof ClientIdHostsIndexRoute;
  ClientIdSidecarIndexRoute: typeof ClientIdSidecarIndexRoute;
}

const ClientIdRouteChildren: ClientIdRouteChildren = {
  ClientIdIndexRoute: ClientIdIndexRoute,
  ClientIdHostsHostIdRoute: ClientIdHostsHostIdRouteWithChildren,
  ClientIdSidecarCreateRoute: ClientIdSidecarCreateRoute,
  ClientIdBillingIndexRoute: ClientIdBillingIndexRoute,
  ClientIdFileLockerIndexRoute: ClientIdFileLockerIndexRoute,
  ClientIdHostsIndexRoute: ClientIdHostsIndexRoute,
  ClientIdSidecarIndexRoute: ClientIdSidecarIndexRoute,
};

const ClientIdRouteWithChildren = ClientIdRoute._addFileChildren(
  ClientIdRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClientIdRoute: ClientIdRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
